/*
 * @Author: your name
 * @Date: 2022-04-14 16:37:02
 * @LastEditTime: 2022-04-14 17:00:00
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\pages\function\reseturl\locales.ts
 */
export const EnumPageMeta: IEnumPageMeta = {
    /** 页面名称 */
    title: "isg重置url",
    layout: null,
    login: true
}
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {

}

export default {
    en: {

    },
    zh: {

    }
}
